type ImageWrapperProps = {
  src: string;
  alt: string;
  className?: string;
};

const ImageWrapper = ({ src, alt, className }: ImageWrapperProps) => {
  return (
    <div className={`overflow-hidden rounded-t-xl ${className}`}>
      <img src={src} alt={alt} className="w-full h-full object-cover" />
    </div>
  );
};

export default ImageWrapper;
